import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { MdCached } from "react-icons/md";
import { PopupModal } from "../alert/alert.Dismiss";
import { REFRESH_CLAIM_BALANCE_FAILED } from "../../../graphql/orderGroup/mutation";
import _ from "lodash";

const RefreshClaimBalanceFailed = ({ setSelectedIds, idIn }) => {
    const [content, setContent] = useState('');
    const [gbColor, setBgColor] = useState('');
    const [centered, setCentered] = useState('');
    const [title, setTitle] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const filter = useMemo(() => { return { id: idIn} }, [idIn]);


    const handleModal = ({ newTitle, newCentered, newContent, newBgColor }) => {
        setModalShow(true)
        setTitle(newTitle || 'ທວງຍອດລູກຄ້າ');
        setCentered(newCentered);
        setContent(newContent);
        setBgColor(newBgColor);
    }

    return (
        <>
            <Button
                className="w-100 text-left"
                variant="light"
                disabled={idIn?.length >= 1 ? false : true}
                // style={{ background: COLOR_APP, border: 'none' }}
                onClick={() => handleModal({
                    newTitle: "ຣີເຟສ",
                    newCentered: "ຣີເຟສທວງຍອດທີ່ເກີດຂໍ້ຜີດຜາດ",
                    newContent: "ອໍເດີຈະ ຣີເຟສໃຫມ່ ເພີ່ອໃຫ້ສາມາດສົ່ງທວງຍອດໄດ້ອີກຄັ້ງ....", newBgColor: "bg-warning text-white"
                })}
            > <MdCached />ຣີທວງຍອດຜີດຜາດ</Button>
            <PopupModal
                show={modalShow}
                // onHide={() => { setSelectedIds([]); setModalShow(false) }}
                onCancel={() => { setSelectedIds([]); setModalShow(false) }}
                title={title}
                centered={centered}
                content={content}
                bgColor={gbColor}
                apiPath={REFRESH_CLAIM_BALANCE_FAILED}
                filter={filter}
            />
        </>
    );
};

export default RefreshClaimBalanceFailed;
